import { Button } from '@design-system';
import { useTranslation } from 'next-i18next';
import { useState } from 'react';

import { Works } from '../../../../components/Checkout/Works';
import { useCheckoutCtx } from '../../../../providers/CheckoutProvider';

export const SelectWorks = () => {
  const {
    allowMultipleSelections,
    artistName,
    checkoutLoading,
    currencyCode,
    enteredWorkIds,
    framingProducts,
    goToShopifyCheckout,
    hasPendingFraming,
    isLinkedDraw,
    isPreOrderFlow,
    maxQuantity,
    preOrdersEnabled,
    selectedWorkIds,
    setFramingSelections,
    setMaxQuantity,
    step,
    summaryProps,
    toggleWork,
    works,
  } = useCheckoutCtx();
  const { t } = useTranslation('checkout');
  const [showFramingErrors, setShowFramingErrors] = useState(false);

  const handleContinue = () => {
    if (hasPendingFraming) {
      setShowFramingErrors(true);
      return;
    }

    if (allowMultipleSelections) {
      void goToShopifyCheckout();
      return;
    }

    step.goNext();
  };

  return (
    <div className="flex w-full flex-col gap-9 lg:gap-12">
      <Works
        allowMultipleSelections={allowMultipleSelections}
        artistName={artistName}
        currencyCode={currencyCode}
        enteredItemIds={enteredWorkIds}
        framingProducts={framingProducts}
        itemInOrderIds={selectedWorkIds}
        items={works.map((work) => ({
          allowMultiple: work.allowMultiple,
          id: work.id,
          imageAlt: work.imageAlt,
          imageSrc: work.imageSrc,
          price: work.price,
          quantity: work.quantity,
          quantityLimit: work.quantityLimit,
          soldOut: work.soldOut,
          title: work.title,
        }))}
        maxQuantity={maxQuantity}
        onFramingChange={setFramingSelections}
        onMaxQuantityChange={setMaxQuantity}
        onToggleItem={toggleWork}
        preOrdersEnabled={preOrdersEnabled}
        showFramingErrors={showFramingErrors}
        isLinkedDraw={isLinkedDraw}
        isPreOrderFlow={isPreOrderFlow}
        summaryProps={summaryProps}
      />

      <Button
        disabled={selectedWorkIds.length === 0}
        fullWidth
        label={
          allowMultipleSelections
            ? t('orderReview.buy.continue')
            : t('orderReview.continue')
        }
        loading={checkoutLoading}
        onClick={handleContinue}
        variant="primary"
      />
    </div>
  );
};
